/** Shared navbar design tokens — navy from brand logo */
export const NAV = {
  navy: "#0f2847",
  navyMuted: "rgba(15, 40, 71, 0.08)",
  navyHover: "rgba(15, 40, 71, 0.12)",
  ink: "#1a1d21",
  inkMuted: "#5c6370",
  line: "#e4e7ec",
  surface: "#ffffff",
  surfaceSubtle: "#f6f7f9",
  chipRowBg: "#f8f9fb",
  chipRowInset: "inset 0 1px 0 rgba(255, 255, 255, 0.75)",
  /** Laptop / desktop category strip (row 2) */
  categoryRowBg: "#0a0a0a",
  categoryChipOnDark: "rgba(255, 255, 255, 0.94)",
  categoryChipBorderOnDark: "rgba(255, 255, 255, 0.28)",
  /** Category chip hover / active — white text + white glow (on dark fill) */
  categoryChipHoverFill: "#0f2847",
  categoryChipActiveFill: "#163a5e",
  categoryChipShadowHover:
    "0 0 0 1px rgba(255, 255, 255, 0.35), 0 8px 32px rgba(255, 255, 255, 0.28)",
  categoryChipShadowActive:
    "0 0 0 1px rgba(255, 255, 255, 0.45), 0 4px 22px rgba(255, 255, 255, 0.22)",
  categoryChipShadowFocus:
    "0 0 0 2px #0a0a0a, 0 0 0 5px rgba(255, 255, 255, 0.55), 0 8px 28px rgba(255, 255, 255, 0.25)",
  shadowBar:
    "0 1px 0 rgba(15, 40, 71, 0.06), 0 8px 24px -8px rgba(15, 40, 71, 0.12)",
  /** When page is scrolled — navbar stays fixed, reads “stacked” on top */
  shadowBarScrolled:
    "0 1px 0 rgba(15, 40, 71, 0.1), 0 10px 40px -8px rgba(15, 40, 71, 0.16)",
  shadowMenu: "0 12px 40px rgba(15, 40, 71, 0.14)",
  radiusChip: 2,
  transition:
    "color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease",
  /** Laptop / desktop search field */
  searchInset: "inset 0 1px 2px rgba(15, 40, 71, 0.07)",
  searchHoverLift: "0 4px 18px rgba(15, 40, 71, 0.11)",
  searchFocusLift:
    "0 0 0 3px rgba(15, 40, 71, 0.08), 0 10px 32px rgba(15, 40, 71, 0.14)",
  /** Subcategory lists — desktop Menu + mobile Drawer (same look) */
  categorySubmenuBg: "#f8fafc",
  categorySubmenuShadow:
    "0 4px 6px -1px rgba(15, 40, 71, 0.06), 0 16px 40px -6px rgba(15, 40, 71, 0.16)",
  categorySubmenuBorder: "rgba(15, 40, 71, 0.1)",
  categorySubmenuRowHover: "rgba(15, 40, 71, 0.07)",
  /** Category pills — default resting shadow on dark strip */
  categoryChipRestShadow: "0 2px 8px rgba(0, 0, 0, 0.28)",
};
